<template>
    <div class="home" v-if="doneLoading">
        <b-container fluid>
            <b-row>
                <b-col>
                    <h1>CNA Interstate Endorsement Application Rejection</h1>
                </b-col>
            </b-row>
            <div class="card">
                <div class="card-header">Certification Information</div>
                <div class="card-body">
                    <b-row>
                        <b-col cols="12">
                            <p class="font-weight-normal">
                                Application for Certification as {{certificate.type.description}}.
                            </p>
                        </b-col>
                    </b-row>
                    <b-row v-if="showCertificationCorrections">
                        <b-col cols="12">
                            <div>Click the checkbox next to the fields that have issues.</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="showCertificationCorrections">
                            <BaseCheckboxInput  v-model="certificationCorrections.state" :v="$v.certificationCorrections.state"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="certificationCorrections.state?'text-danger':''" label="State Certified"
                                            :value="endorsement.state ? opts.stateOptions.find(x=>x.value===endorsement.state).text : ''"/>
                        </b-col>
                        <b-col cols="0" v-if="showCertificationCorrections">
                            <BaseCheckboxInput v-model="certificationCorrections.certificateNumber" :v="$v.certificationCorrections.certificateNumber"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="certificationCorrections.certificateNumber?'text-danger':''" label="Certificate #" :value="endorsement.certificateNumber"/>
                        </b-col>
                        <b-col cols="0" v-if="showCertificationCorrections">
                            <BaseCheckboxInput v-model="certificationCorrections.workPeriod" :v="$v.certificationCorrections.workPeriod"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput v-bind:class="certificationCorrections.workPeriod?'text-danger':''" label="Has Worked in Last 24 Months" :value="endorsement.workPeriod?'Yes':'No'"/>
                        </b-col>
                        <b-col cols="0" v-if="showCertificationCorrections">
                            <BaseCheckboxInput v-model="certificationCorrections.testPeriod" :v="$v.certificationCorrections.testPeriod"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput v-bind:class="certificationCorrections.testPeriod?'text-danger':''" label="Has Tested in Last 24 Months" :value="endorsement.testPeriod?'Yes':'No'"/>
                        </b-col>
                        <b-col cols="0" v-if="showCertificationCorrections">
                            <BaseCheckboxInput v-model="certificationCorrections.testDate" :v="$v.certificationCorrections.testDate"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput v-bind:class="certificationCorrections.testDate?'text-danger':''" label="Date Tested in Endorsing State" :value="endorsement.testDate"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <BaseParagraphInput v-if="showCertificationCorrections" v-model="certificationCorrections.reasons" :v="$v.certificationCorrections.reasons" label="Rejections reasons for certification details" tip="Will be shared with applicant"/>
                            <BaseTextOutput v-else-if="certificationCorrections.reasons" v-model="certificationCorrections.reasons" label="Reasons"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-button variant="secondary" @click="showCertificationCorrections=!showCertificationCorrections">{{showCertificationCorrections?'Close':'Open'}} Corrections</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Applicant Information</div>
                <div class="card-body">
                    <b-row v-if="showPersonalInfoCorrections">
                        <b-col cols="12">
                            <div>Click the checkbox next to the fields that have issues.</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <div>Name and email are bound to Keycloak and cannot be corrected here.</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3">
                            <BaseTextOutput label="Last Name" :value="profile.lastName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="First Name" :value="profile.firstName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Middle Name" :value="profile.middleName"/>
                        </b-col>
                        <b-col cols="3">
                            <BaseTextOutput label="Email Address" :value="profile.contact.email"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.streetAddress" :v="$v.personalInfoCorrections.address.streetAddress"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="personalInfoCorrections.address.streetAddress?'text-danger':''" label="Street Address" :value="profile.contact.address.streetAddress"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.city" :v="$v.personalInfoCorrections.address.city"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="personalInfoCorrections.address.city?'text-danger':''" label="City" :value="profile.contact.address.city"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.state" :v="$v.personalInfoCorrections.address.state"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="personalInfoCorrections.address.state?'text-danger':''" label="State" :value="profile.contact.address.state ?
                            opts.stateOptions.find(x=>x.value===profile.contact.address.state).text : ''"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.address.postalCode" :v="$v.personalInfoCorrections.address.postalCode"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="personalInfoCorrections.address.postalCode?'text-danger':''" label="Zip" :value="profile.contact.address.postalCode"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.phone" :v="$v.personalInfoCorrections.phone"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="personalInfoCorrections.phone?'text-danger':''" label="Cell Phone Number" :value="profile.contact.phone"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.dob" :v="$v.personalInfoCorrections.dob"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput v-bind:class="personalInfoCorrections.dob?'text-danger':''" label="Date Of Birth" :value="formatDate(profile.dateOfBirth)"/>
                        </b-col>
                        <b-col cols="0" v-if="showPersonalInfoCorrections">
                            <BaseCheckboxInput v-model="personalInfoCorrections.ssn" :v="$v.personalInfoCorrections.ssn"/>
                        </b-col>
                        <b-col cols="2">
                            <BaseTextOutput  v-bind:class="personalInfoCorrections.ssn?'text-danger':''" label="Social Security Number" :value="profile.ssn"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <BaseParagraphInput v-if="showPersonalInfoCorrections" v-model="personalInfoCorrections.reasons" :v="$v.personalInfoCorrections.reasons" label="Rejections reasons for personal details" tip="Will be shared with applicant"/>
                            <BaseTextOutput v-else-if="personalInfoCorrections.reasons" v-model="personalInfoCorrections.reasons" label="Reasons"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-button variant="secondary" @click="showPersonalInfoCorrections=!showPersonalInfoCorrections">{{showPersonalInfoCorrections?'Close':'Open'}} Corrections</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Application Attachments</div>
                <div class="card-body">
                    <b-row v-if="showAttachmentCorrections">
                        <b-col cols="12">
                            <div>Click the checkbox next to the attachments that have issues.</div>
                        </b-col>
                    </b-row>
                    <div v-for="(attachment, index) in application.attachments" :key="attachment.attachmentId">
                        <b-row v-bind:class="attachmentCorrections[index].mark?'text-danger':''">
                            <b-col cols="0" v-if="showAttachmentCorrections">
                                <BaseCheckboxInput v-model="attachmentCorrections[index].mark" :v="$v.attachmentCorrections.$each[index].mark"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput label="File Name" :value="attachment.filename"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput label="Type" :value="attachment.type.description"/>
                            </b-col>
                            <b-col cols="2" v-if="attachment.type.code==='OTH'">
                                <BaseTextOutput label="Other Type" :value="attachment.otherType"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput label="OCR Grade" :value="attachment.grade?attachment.grade.description:'N/A'"/>
                            </b-col>
                            <b-col cols="2">
                                <b-button variant="secondary" @click="downloadAttachment(attachment)">Download</b-button>
                            </b-col>
                        </b-row>
                        <b-row v-if="attachment.concerns">
                            <b-col cols="12">
                                <BaseTextOutput label="OCR Concerns" :value="attachment.concerns"/>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col cols="12">
                            <BaseParagraphInput v-if="showAttachmentCorrections" v-model="attachmentCorrectionReasons" :v="$v.attachmentCorrectionReasons" label="Rejection reasons for attachments" tip="Will be shared with applicant" />
                            <BaseTextOutput v-else-if="attachmentCorrectionReasons" label="Reasons" :value="attachmentCorrectionReasons"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-button variant="secondary" @click="showAttachmentCorrections=!showAttachmentCorrections">{{showAttachmentCorrections?'Close':'Open'}} Corrections</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div class="card">
                <div class="card-header">Facility</div>
                <div class="card-body">
                    <b-row v-if="showFacilityCorrections">
                        <b-col cols="12">
                            <div>Click the checkbox next to the fields that have issues.</div>
                        </b-col>
                    </b-row>
                    <div v-for="employer in application.employers" :key="employer.id">
                        <b-row>
                            <b-col cols="0" v-if="showFacilityCorrections">
                                <BaseCheckboxInput v-model="facilityCorrections.name" :v="$v.facilityCorrections.name"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput v-bind:class="facilityCorrections.name?'text-danger':''" label="Facility Name" :value="employer.name"/>
                            </b-col>
                            <b-col cols="0" v-if="showFacilityCorrections">
                                <BaseCheckboxInput v-model="facilityCorrections.staffingAgency" :v="$v.facilityCorrections.staffingAgency"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput v-bind:class="facilityCorrections.staffingAgency?'text-danger':''" label="Staffing Agency" :value="employer.staffingAgency?'Yes':'No'"/>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="0" v-if="showFacilityCorrections">
                                <BaseCheckboxInput v-model="facilityCorrections.address.streetAddress" :v="$v.facilityCorrections.address.streetAddress"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput v-bind:class="facilityCorrections.address.streetAddress?'text-danger':''" label="Street Address" :value="employer.address.streetAddress"/>
                            </b-col>
                            <b-col cols="0" v-if="showFacilityCorrections">
                                <BaseCheckboxInput v-model="facilityCorrections.address.city" :v="$v.facilityCorrections.address.city"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput v-bind:class="facilityCorrections.address.city?'text-danger':''" label="City" :value="employer.address.city"/>
                            </b-col>
                            <b-col cols="0" v-if="showFacilityCorrections">
                                <BaseCheckboxInput v-model="facilityCorrections.address.state" :v="$v.facilityCorrections.address.state"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput v-bind:class="facilityCorrections.address.state?'text-danger':''" label="State" :value="employer.address.state
                                ? opts.stateOptions.find(x=>x.value===employer.address.state).text : ''"/>
                            </b-col>
                            <b-col cols="0" v-if="showFacilityCorrections">
                                <BaseCheckboxInput v-model="facilityCorrections.address.postalCode" :v="$v.facilityCorrections.address.postalCode"/>
                            </b-col>
                            <b-col cols="2">
                                <BaseTextOutput v-bind:class="facilityCorrections.address.postalCode?'text-danger':''" label="Zip Code" :value="employer.address.postalCode"/>
                            </b-col>
                        </b-row>
                    </div>
                    <b-row>
                        <b-col cols="12">
                            <BaseParagraphInput v-if="showFacilityCorrections" v-model="facilityCorrections.reasons" :v="$v.facilityCorrections.reasons" label="Rejections reasons for facility details" tip="Will be shared with applicant"/>
                            <BaseTextOutput v-else-if="facilityCorrections.reasons" label="Reasons" :value="facilityCorrections.reasons"/>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-button variant="secondary" @click="showFacilityCorrections=!showFacilityCorrections">{{showFacilityCorrections?'Close':'Open'}} Corrections</b-button>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <div>
                <b-row v-if="submitError">
                    <b-col cols="12">
                        <div class="text-danger">You need to mark something for corrections</div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-button variant="primary" @click="submit" class="m-2" :disabled="disableButton">Submit Corrections</b-button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-button variant="secondary" :href="'/review-endorsement/'+application.id" class="m-2">Cancel</b-button>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<script>
    import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
    import BaseParagraphInput from "@/components/templates/input/BaseParagraphInput";
    import axios from 'axios';
    import {required, requiredIf, minLength, maxLength} from 'vuelidate/lib/validators'
    import moment from 'moment';
    import {toastService} from "@/mixins/toastService";
    import {commonOptions} from "@/mixins/commonOptions";
    import BaseCheckboxInput from "@/components/templates/input/BaseCheckboxInput";

    export default {
        name: "EndorsementReview",
        components: {
            BaseTextOutput,
            BaseParagraphInput,
            BaseCheckboxInput
        },
        mixins: [
            toastService,
            commonOptions
        ],
        data: () => ({
            disableButton: false,
            doneLoading: false,
            application: null,
            profile: null,
            certificate: null,
            endorsement: null,
            showPersonalInfoCorrections: false,
            personalInfoCorrections: {
                address: {
                    streetAddress: false,
                    city: false,
                    state: false,
                    postalCode: false
                },
                phone: false,
                dob: false,
                ssn: false,
                reasons: ''
            },
            showCertificationCorrections: false,
            certificationCorrections: {
                state: false,
                certificateNumber: false,
                testPeriod: false,
                testDate: false,
                workPeriod: false,
                reasons: ''
            },
            showAttachmentCorrections: false,
            attachmentCorrections: [],
            attachmentCorrectionReasons: '',
            facilityCorrections:{
                name: false,
                staffingAgency: false,
                address:{
                    streetAddress: false,
                    city: false,
                    state: false,
                    postalCode: false,
                },
                reasons: ''
            },
            showFacilityCorrections: false,
            submitError: false,
        }),
        created() {
            this.loadApplication()
        },
        methods: {
            loadApplication() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/renewal/${this.$route.params.id}`)
                    .then(response => {
                        this.application = response.data.application;
                        this.profile = response.data.profile;
                        this.certificate = response.data.certificate;
                        this.endorsement = response.data.endorsement;
                        for(let i=0; i<response.data.application.attachments.length;i++){
                            this.attachmentCorrections.push(
                                {
                                    id: response.data.application.attachments[i].attachmentId,
                                    mark: false,
                                }
                            )
                        }
                        this.$nextTick(()=>{
                            this.doneLoading = true;
                        })
                    })
            },
            formatDate(unformattedDate) {
                let formattedDate = moment(unformattedDate);
                if (!formattedDate.isValid()) return '';
                return formattedDate.format("MM/DD/YYYY")
            },
            downloadAttachment(attachment){
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/${attachment.attachmentId}`)
                    .then(response=>{
                        window.open(response.data,"_blank");
                    }).catch(error=>{
                        this.showRootToast('Attachment download failed','Unable to download this attachment','danger')
                });
            },
            submit(){
                this.disableButton = true;
                if(this.checkForCorrections()){
                    this.submitError=false;
                    let payload={
                        personalInfoCorrections: this.personalInfoCorrections,
                        facilityCorrections: this.facilityCorrections,
                        certificationCorrections: this.certificationCorrections,
                        attachmentCorrections: this.attachmentCorrections,
                        attachmentCorrectionReasons: this.attachmentCorrectionReasons
                    };
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/approval/rejectInterstate/${this.$route.params.id}`, JSON.stringify(payload))
                        .then(response=>{
                            this.showRootToast('Application returned', 'The application has been successfully returned to applicant', 'success');
                            this.loadApplication();
                        }).catch(error=> {
                        if (error.response.status === 406) {
                            this.showRootToast('Error returning application', 'This application is not in a status from which it can be returned to the applicant', 'danger');
                        } else if (error.response.status === 404) {
                            this.showRootToast('Not found', 'Application not found', 'danger');
                        } else {
                            this.showRootToast('Error returning application', 'An error occurred while returning this application', 'danger');
                        }
                      this.disableButton=false;
                    })
                }
                else{
                    this.submitError=true;
                    this.disableButton=false;
                }
            },
            checkForCorrections(){
                let iter = [];
                let flattenedObject = this.flattenObject(this.personalInfoCorrections);
                iter = iter.concat(Object.values(flattenedObject));
                flattenedObject = this.flattenObject(this.facilityCorrections);
                iter = iter.concat(Object.values(flattenedObject));
                flattenedObject = this.certificationCorrections;
                iter = iter.concat(Object.values(flattenedObject));

                for(let i=0;i<this.attachmentCorrections.length;i++){
                    iter.push(this.attachmentCorrections[i].mark);
                }
                for(let i=0;i<iter.length;i++){
                    if(iter[i]){
                        return true;
                    }
                }
                return false;
            },
            flattenObject(obj){
                const flattened = {}

                Object.keys(obj).forEach((key) => {
                    const value = obj[key]

                    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                        Object.assign(flattened, this.flattenObject(value))
                    } else {
                        flattened[key] = value
                    }
                })

                return flattened
            },
            showRootToast(title, message, type) {
                this.$root.$bvToast.toast(message, {
                    title: title,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: type,
                    appendToast: true,
                    noAutoHide:true
                })
                this.toastFocus()
            },
            toastFocus() {
                setTimeout(() => {
                    let elem = document.getElementsByClassName("toast")
                    elem = elem[elem.length-1]
                    elem.focus()
                }, 100)
            },
        },
        validations: {
            personalInfoCorrections: {
                address: {
                    streetAddress: {required: false},
                    city: {required: false},
                    state: {required: false},
                    postalCode: {required: false}
                },
                phone: {required: false},
                dob: {required: false},
                ssn: {required: false},
                reasons: {required: false},
            },
            certificationCorrections: {
                state: {required: false},
                certificateNumber: {required: false},
                testPeriod: {required: false},
                testDate: {required: false},
                workPeriod: {required: false},
                reasons: {required: false}
            },
            attachmentCorrections: {
                $each: {
                    id: {required: false},
                    mark: {required: false}
                }
            },
            attachmentCorrectionReasons: {required: false},
            facilityCorrections:{
                name: {required: false},
                staffingAgency: {required: false},
                address:{
                    streetAddress: {required: false},
                    city: {required: false},
                    state: {required: false},
                    postalCode: {required: false},
                },
                reasons: {required: false},
            },
        },
        computed: {
            isActionable: function () {
                let statuses = ["Received", "In Progress", "Reopened", "Resubmitted", "Returned"];
                return statuses.some(s => s === this.application.status.description)
            },
            isReadonly() {
                return this.$keycloak.authenticated && (this.$keycloak.hasResourceRole('readonly'))
            },
        }
    }


</script>

<style scoped>
    p {
        font-weight: 700;
    }

</style>